<!-- Display as Carousel: 4 accommodations or more -->
<div class="!px-5">
	<swiper-container #swiperRef init="false">
		@for (accommodation of accommodationLocations(); track accommodation.name) {
			<swiper-slide>
				<uc-accommodation-card
					[image]="accommodation.image"
					[name]="accommodation.name"
					[price]="accommodation.price"
					[totalRooms]="accommodation.total_rooms"
					[universityUrl]="universityUrl()"
					[uniId]="uniId()"
					[product]="product()"
					[externalUrl]="externalUrl()"
					[carousel]="true"
					[uniName]="uniName()"
					[ugSearchOrderPosition]="ugSearchOrderPosition()"
				/>
			</swiper-slide>
		}
	</swiper-container>
</div>
